export default __webpack_public_path__ + "static/media/atlassian-community-opengraph.1ca3ac45.png";